import { modifier } from 'ember-modifier';
import isRemovedString from 'garaje/helpers/is-removed-string';

const ITALIC_CLASS = 'italic';

interface ItalicizeIfRemovedSignature {
  Args: {
    Positional: [value?: string | null];
  };
  Element: HTMLElement;
}

/**
 * Modifier to italicize a display element whose text represents a "removed" value.
 *
 * Unlike {{handle-removed-string}}, this modifier only toggles a styling class — it never
 * mutates text content. Text replacement for these elements is handled declaratively by the
 * {{removed-string}} helper, so this is safe to apply to Glimmer-owned text nodes without
 * fighting reactivity.
 */
export default modifier<ItalicizeIfRemovedSignature>((element, [value]) => {
  if (!isRemovedString(value)) return;

  const hadItalicClass = element.classList.contains(ITALIC_CLASS);
  element.classList.add(ITALIC_CLASS);

  return () => {
    if (!hadItalicClass) {
      element.classList.remove(ITALIC_CLASS);
    }
  };
});
